import React from 'react'
import { makePlanningHeadcountData } from '../../data/planningHeadcount'
import { HeadcountTable } from '../HeadcountTable'

const data = makePlanningHeadcountData()

export const PlanningHeadcount: React.FC = () => <HeadcountTable />
